import { useState } from "react";
import { statusLog } from "@/mocks/homeData";

const filters = ["全部", "正常", "更新", "维护", "通知"];

const tagStyle: Record<string, string> = {
  正常: "bg-primary-100 text-primary-800",
  更新: "bg-accent-100 text-accent-900",
  维护: "bg-secondary-100 text-secondary-900",
  通知: "bg-background-200 text-foreground-800",
};

export default function StatusSection() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? statusLog : statusLog.filter((item) => item.tag === active);

  return (
    <section id="status" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
          <div className="max-w-2xl">
            <p className="font-label text-sm text-primary-600 font-medium">地址状态</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-snug">
              最近更新记录与入口状态
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base">
              本页按每日巡检的频率核对入口，一旦发现变动就会同步到这里。下面是最近的核对与更新记录，
              你可以按状态筛选查看。
            </p>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100 px-5 py-4 min-w-[220px]">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse-soft" />
              <span className="text-sm font-medium text-foreground-900">当前入口状态</span>
            </div>
            <p className="mt-1.5 font-heading font-bold text-xl text-primary-700">正常可用</p>
            <p className="text-xs text-foreground-500">最近核对：2026-10-09</p>
          </div>
        </div>

        <div className="mt-7 flex flex-wrap gap-1.5">
          {filters.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setActive(f)}
              className={`px-3.5 py-1.5 rounded-full text-xs md:text-sm transition-colors cursor-pointer whitespace-nowrap border ${
                active === f
                  ? "bg-primary-500 text-background-50 border-primary-500"
                  : "bg-background-100 text-foreground-700 border-background-200 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="mt-5 rounded-lg border border-background-200 overflow-hidden bg-background-50">
          {list.map((item, index) => (
            <div
              key={item.title}
              className={`flex flex-col md:flex-row md:items-start gap-3 md:gap-5 px-4 md:px-6 py-4 md:py-5 ${
                index !== list.length - 1 ? "border-b border-background-200" : ""
              }`}
            >
              <div className="flex items-center gap-3 md:w-44 flex-shrink-0">
                <span
                  className={`px-2.5 py-1 rounded-full text-[11px] font-label ${
                    tagStyle[item.tag] ?? "bg-background-200 text-foreground-800"
                  }`}
                >
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-500 font-label">{item.date}</span>
              </div>
              <div className="flex-1">
                <h3 className="font-medium text-foreground-950 text-sm md:text-base">{item.title}</h3>
                <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{item.detail}</p>
              </div>
            </div>
          ))}
          {list.length === 0 && (
            <div className="px-6 py-10 text-center text-sm text-foreground-500">该状态下暂无记录</div>
          )}
        </div>
      </div>
    </section>
  );
}